import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Offcanvas, OffcanvasBody, OffcanvasHeader,
} from 'reactstrap';
// import { Link } from 'react-router-dom';

function ClientNav(props) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCanvas = () => {
    setIsOpen(!isOpen);
  };

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      <Offcanvas
        isOpen={isOpen}
        direction="end"
      >
        <OffcanvasHeader toggle={toggleCanvas}>
          {props.t('Saved Links')}
        </OffcanvasHeader>
        <OffcanvasBody>...</OffcanvasBody>
      </Offcanvas>
    </>
  );
}

ClientNav.defaultProps = {
  t: (x) => (x),
};

ClientNav.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ClientNav));
